var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lock-screen-btn-con"},[_c('Badge',{nativeOn:{"click":function($event){return _vm.toAbnormal.apply(null, arguments)}}},[_c('Icon',{attrs:{"type":"ios-videocam-outline","size":30}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }